import { useEffect } from "react";

const SITE = "https://pendli.no";
const DEFAULT_IMAGE = `${SITE}/og-image-v2.png`;
const IMAGE_WIDTH = "1200";
const IMAGE_HEIGHT = "630";
const IMAGE_ALT = "Pendli — parkering nær stasjonen. Lanseres i Asker.";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * useSeo — sets per-route title, meta description, canonical, and Open Graph / Twitter tags.
 * @param {{title: string, description: string, path: string, lang?: string, image?: string}} opts
 */
export function useSeo({ title, description, path, lang = "no", image = DEFAULT_IMAGE }) {
  useEffect(() => {
    const url = `${SITE}${path === "/" ? "/" : path}`;
    document.title = title;
    document.documentElement.lang = lang === "no" ? "nb" : "en";

    upsertMeta("name", "description", description);
    upsertLink("canonical", url);

    // Open Graph
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:image", image);
    upsertMeta("property", "og:image:secure_url", image);
    upsertMeta("property", "og:image:type", "image/png");
    upsertMeta("property", "og:image:width", IMAGE_WIDTH);
    upsertMeta("property", "og:image:height", IMAGE_HEIGHT);
    upsertMeta("property", "og:image:alt", IMAGE_ALT);
    upsertMeta("property", "og:site_name", "Pendli");
    upsertMeta("property", "og:locale", lang === "no" ? "nb_NO" : "en_US");

    // Twitter
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);
    upsertMeta("name", "twitter:image:alt", IMAGE_ALT);
  }, [title, description, path, lang, image]);
}
